export default __webpack_public_path__ + "static/wallpaper-5-pc-ecb0b981c815f995b0873d300580bb8a.png";